import {
  Amendoim,
  Camarao,
  Leite,
  Noz,
  Ovo,
  Pao,
  Peixe,
  Planta,
  Corantes,
} from "../../../assets/images";

export const allergens = [
  {
    key: "gluten",
    label: "Glúten",
    desc: "Trigo, aveia, cevada, centeio e derivados",
    icon: Pao,
  },
  {
    key: "milk",
    label: "Leite",
    desc: "Leite de todos os mamíferos e seus derivados",
    icon: Leite,
  },
  {
    key: "eggs",
    label: "Ovos",
    desc: "Ovos e seus derivados",
    icon: Ovo,
  },
  {
    key: "crustaceans",
    label: "Crustáceos",
    desc: "Camarões, lagostas, caranguejos, entre outros",
    icon: Camarao,
  },
  {
    key: "peanuts",
    label: "Amendoim",
    desc: "Amendoim e seus derivados",
    icon: Amendoim,
  },
  {
    key: "treeNuts",
    label: "Oleaginosas / Frutos Secos",
    desc: "Amêndoas, avelãs, castanhas, macadâmias, nozes-pecã, pistaches, pinhões, entre outros",
    icon: Noz,
  },
  {
    key: "fish",
    label: "Peixes",
    desc: "Peixes e seus derivados",
    icon: Peixe,
  },
  {
    key: "soy",
    label: "Soja",
    desc: "Soja e seus derivados",
    icon: Planta,
  },
  {
    key: "dye",
    label: "Corantes",
    desc: "Corantes alimentares",
    icon: Corantes,
  },
];
